import * as React from 'react';
import {useTranslation} from 'react-i18next';
import styles from './ButtonEffects.module.css';
import {useRippleEffect} from '../../hooks/useRippleEffect';

type Props = {
	text: string;
	onClick?: any;
	type: 'submit' | 'reset' | 'button' | undefined;
	disabled?: boolean;
	loading?: boolean;
	className?: string;
};

const LightGreenButton = ({text, onClick, type, disabled, loading, className}: Props) => {
	const {t} = useTranslation();
	const {ripples, createRipple} = useRippleEffect();

	const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		if (disabled || loading) return;

		createRipple(e);

		// Вызываем оригинальный onClick
		if (onClick) onClick(e);
	};

	return (
		<button
			onClick={handleClick}
			type={type}
			disabled={disabled || loading}
			className={`review__btn btn-main ${styles.lightGreenButton} ${loading ? styles.loading : ''} ${className || ''}`}
		>
			{loading ? t('Завантаження...') : t(text)}
			{ripples.map((ripple) => (
				<span
					key={ripple.id}
					className={styles.ripple}
					style={{
						left: ripple.x - 10,
						top: ripple.y - 10,
					}}
				/>
			))}
		</button>
	);
};

export default LightGreenButton;
